import { createElementBlock as c, openBlock as o, createElementVNode as n, defineComponent as h, ref as f, resolveComponent as r, createBlock as a, withCtx as d, createVNode as s } from "vue";
import m from "./InputIcon-DYMgHv8r.js";
import { _ as v } from "./_plugin-vue_export-helper-CHgC5LLL.js";
function w(t, e) {
  return o(), c("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    n("path", {
      "fill-rule": "evenodd",
      d: "M3.28 2.22a.75.75 0 0 0-1.06 1.06l14.5 14.5a.75.75 0 1 0 1.06-1.06l-1.745-1.745a10.029 10.029 0 0 0 3.3-4.38 1.651 1.651 0 0 0 0-1.185A10.004 10.004 0 0 0 9.999 3a9.956 9.956 0 0 0-4.744 1.194L3.28 2.22ZM7.752 6.69l1.092 1.092a2.5 2.5 0 0 1 3.374 3.373l1.091 1.092a4 4 0 0 0-5.557-5.557Z",
      "clip-rule": "evenodd"
    }),
    n("path", { d: "m10.748 13.93 2.523 2.523a9.987 9.987 0 0 1-3.27.547c-4.258 0-7.894-2.66-9.337-6.41a1.651 1.651 0 0 1 0-1.186A10.007 10.007 0 0 1 2.839 6.02L6.07 9.252a4 4 0 0 0 4.678 4.678Z" })
  ]);
}
function _(t, e) {
  return o(), c("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    n("path", { d: "M10 12.5a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5Z" }),
    n("path", {
      "fill-rule": "evenodd",
      d: "M.664 10.59a1.651 1.651 0 0 1 0-1.186A10.004 10.004 0 0 1 10 3c4.257 0 7.893 2.66 9.336 6.41.147.381.146.804 0 1.186A10.004 10.004 0 0 1 10 17c-4.257 0-7.893-2.66-9.336-6.41ZM14 10a4 4 0 1 1-8 0 4 4 0 0 1 8 0Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function g(t, e) {
  return o(), c("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    n("path", {
      "fill-rule": "evenodd",
      d: "M10 1a4.5 4.5 0 0 0-4.5 4.5V9H5a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2v-6a2 2 0 0 0-2-2h-.5V5.5A4.5 4.5 0 0 0 10 1Zm3 8V5.5a3 3 0 1 0-6 0V9h6Z",
      "clip-rule": "evenodd"
    })
  ]);
}
const I = h({
  components: {
    InputIcon: m,
    EyeIcon: _,
    EyeSlashIcon: w
  },
  setup: () => ({
    hidden: f(!0),
    LockClosedIcon: g
  })
}), x = { class: "tt-h-full tt-flex tt-items-center tt-px-1 tt-bg-gray-50 tt-text-gray-500 tt-rounded-r-lg" }, y = { class: "tt-h-full tt-flex tt-items-center tt-px-1 tt-bg-gray-50 tt-text-gray-500 tt-rounded-r-lg" };
function C(t, e, k, E, Z, $) {
  const i = r("EyeIcon"), l = r("InputIcon"), p = r("EyeSlashIcon");
  return t.hidden ? (o(), a(l, {
    key: 0,
    type: "password",
    icon: t.LockClosedIcon
  }, {
    end: d(() => [
      n("span", x, [
        s(i, {
          class: "tt-w-4 tt-cursor-pointer",
          onClick: e[0] || (e[0] = (u) => t.hidden = !1)
        })
      ])
    ]),
    _: 1
  }, 8, ["icon"])) : (o(), a(l, {
    key: 1,
    type: "text",
    icon: t.LockClosedIcon
  }, {
    end: d(() => [
      n("span", y, [
        s(p, {
          class: "tt-w-4 tt-cursor-pointer",
          onClick: e[1] || (e[1] = (u) => t.hidden = !0)
        })
      ])
    ]),
    _: 1
  }, 8, ["icon"]));
}
const A = /* @__PURE__ */ v(I, [["render", C]]);
export {
  A as default
};
//# sourceMappingURL=InputPassword-CFcOJ5HW.js.map
